import useTreeLineReceiptFormState from './useTreeLineReceiptFormState';
import TreeLineReceiptForm from './TreeLineReceiptForm';
import { TreeLineReceiptDetails } from '@/models/TreeLineReceiptDetails';
import React, { useEffect } from 'react';
import { TreeLineReceiptSubmitState } from './types';

type Props = {
  isActive: boolean;
  defaultLocale: string;
  localeOptions: ReadonlyArray<{ value: string; label: string }>;
  getTreeLineReceiptDetails: (
    applicationId: number,
    localeCode?: string
  ) => Promise<TreeLineReceiptDetails>;
  onLoadError: () => void;
  onStateChange: React.Dispatch<React.SetStateAction<TreeLineReceiptSubmitState>>;
  resetSignal: number;
};

const TreeLineReceiptSection: React.FC<Props> = ({
  isActive,
  defaultLocale,
  localeOptions,
  getTreeLineReceiptDetails,
  onLoadError,
  onStateChange,
  resetSignal,
}) => {
  const {
    treeLinePreviewFields,
    treeLineBillingFields,
    treeLineReceiptApplicationId,
    setTreeLineReceiptApplicationId,
    treeLineReceiptPreview,
    treeLineReceiptLocaleCode,
    setTreeLineReceiptLocaleCode,
    treeLineManualBillingAddress,
    setTreeLineManualBillingAddress,
    treeLineFieldOverrides,
    loadingTreeLineReceiptPreview,
    toggleTreeLineFieldOverride,
    updateTreeLinePreviewField,
    isTreeLineReceiptValid,
    resetTreeLineReceiptForm,
  } = useTreeLineReceiptFormState({
    isActive,
    defaultLocale,
    getTreeLineReceiptDetails,
    onLoadError,
  });

  useEffect(() => {
    onStateChange({
      applicationId: treeLineReceiptApplicationId,
      email: treeLineReceiptPreview.email,
      year: treeLineReceiptPreview.year,
      utilityName: treeLineReceiptPreview.utilityName,
      paymentType: treeLineReceiptPreview.paymentType,
      amountPaid: treeLineReceiptPreview.amountPaid,
      paymentDate: treeLineReceiptPreview.paymentDate,
      transactionId: treeLineReceiptPreview.transactionId,
      customerId: treeLineReceiptPreview.customerId ?? '',
      localeCode: treeLineReceiptLocaleCode,
      manualBillingAddress: treeLineManualBillingAddress,
      isValid: isTreeLineReceiptValid,
    });
  }, [
    isTreeLineReceiptValid,
    onStateChange,
    treeLineManualBillingAddress,
    treeLineReceiptApplicationId,
    treeLineReceiptLocaleCode,
    treeLineReceiptPreview.amountPaid,
    treeLineReceiptPreview.customerId,
    treeLineReceiptPreview.email,
    treeLineReceiptPreview.paymentDate,
    treeLineReceiptPreview.paymentType,
    treeLineReceiptPreview.transactionId,
    treeLineReceiptPreview.utilityName,
    treeLineReceiptPreview.year,
  ]);

  useEffect(() => {
    resetTreeLineReceiptForm();
  }, [resetSignal, resetTreeLineReceiptForm]);

  return (
    <TreeLineReceiptForm
      treeLineReceiptApplicationId={treeLineReceiptApplicationId}
      setTreeLineReceiptApplicationId={setTreeLineReceiptApplicationId}
      treeLineReceiptLocaleCode={treeLineReceiptLocaleCode}
      setTreeLineReceiptLocaleCode={setTreeLineReceiptLocaleCode}
      treeLineManualBillingAddress={treeLineManualBillingAddress}
      setTreeLineManualBillingAddress={setTreeLineManualBillingAddress}
      localeOptions={localeOptions}
      treeLinePreviewFields={treeLinePreviewFields}
      treeLineBillingFields={treeLineBillingFields}
      treeLineReceiptPreview={treeLineReceiptPreview}
      treeLineFieldOverrides={treeLineFieldOverrides}
      updateTreeLinePreviewField={updateTreeLinePreviewField}
      toggleTreeLineFieldOverride={toggleTreeLineFieldOverride}
      loadingTreeLineReceiptPreview={loadingTreeLineReceiptPreview}
    />
  );
};

export default TreeLineReceiptSection;
